import React from 'react';

import Seo from '../components/seo/Seo';
import StructuredData from '../components/seo/StructuredData';
import HomeHero from '../components/home/homehero';
import PartnersCarousel from '../components/home/PartnersCarousel';
import HomeWelcome from '../components/home/HomeWelcome';
import HomeVisionMissionValues from '../components/home/HomeVisionMissionValues';
import HomeServices from '../components/home/HomeServices';
import HomeCta from '../components/home/HomeCta';
import HomeWhyChooseUs from '../components/home/HomeWhyChooseUs';
import HomeFaqNewsletter from '../components/home/HomeFaqNewsletter';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Ancient Engineering',
  url: 'https://www.ancientengineering.co.zw',
  logo: 'https://www.ancientengineering.co.zw/images/logo/Ancient%20Engineering%20logo.png',
  description:
    'Multi-discipline engineering company delivering innovative, agile, and affordable solutions across Mining, Construction, and Manufacturing sectors in Zimbabwe.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'ZW',
    addressLocality: 'Zimbabwe',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'Info@ancientengineering.co.zw',
    contactType: 'Customer Service',
  },
  sameAs: [
    'https://facebook.com',
    'https://twitter.com',
    'https://linkedin.com',
    'https://instagram.com',
  ],
};

export default function Home(): React.ReactElement {
  return (
    <>
      <Seo
        title="Ancient Engineering - Engineering the Future of Industry in Zimbabwe"
        description="Innovative, agile, and affordable multi-discipline engineering solutions across Mining, Construction, and Manufacturing sectors in Zimbabwe. Industrial Automation, Solar PV, Fabrication & Mechanical services."
        keywords="engineering Zimbabwe, industrial automation Zimbabwe, solar PV Zimbabwe, fabrication services, mechanical engineering Zimbabwe, mining engineering, construction engineering"
        ogTitle="Ancient Engineering - Engineering the Future of Industry in Zimbabwe"
        ogDescription="Innovative, agile, and affordable multi-discipline engineering solutions across Mining, Construction, and Manufacturing sectors in Zimbabwe."
        canonical="https://www.ancientengineering.co.zw/"
      />
      <StructuredData data={organizationSchema} />
      <HomeHero />
      <PartnersCarousel direction="left" speedSeconds={12} />
      <HomeWelcome />
      <HomeVisionMissionValues />
      <HomeServices />
      <HomeCta />
      <HomeWhyChooseUs />
      <HomeFaqNewsletter />
    </>
  );
}
